'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactDnd = require('react-dnd');

var _lineConstants = require('../../../common/lines/lineConstants');

var _dndConstants = require('../../utils/dnd/dndConstants');

// Constants
var canvasLineEdgeDropTargetSpec = {
    drop: function drop(props, monitor) {
        if (monitor.didDrop()) return;
        var offsetDiff = monitor.getDifferenceFromInitialOffset() || _dndConstants.NO_DRAG_OFFSET;
        return { offsetDiff: offsetDiff };
    }
}; // Lib


var canvasLineEdgeDropCollect = function canvasLineEdgeDropCollect(connector, monitor) {
    return {
        connectLineEdgeDropTarget: connector.dropTarget()
    };
};

var DROP_TYPES = [_lineConstants.LINE_CONTROL_POINT_DND_TYPE, _lineConstants.LINE_EDGE_DND_TYPE];

exports.default = (0, _reactDnd.DropTarget)(DROP_TYPES, canvasLineEdgeDropTargetSpec, canvasLineEdgeDropCollect);


//////////////////
// WEBPACK FOOTER
// ./src/client/element/line/canvasLineEdgeDropTarget.js
// module id = 1993
// module chunks = 0